import React, { useCallback, useRef } from "react";
import { CountryCodesCountType, CountryCodeSelect, SelectedCountriesType } from "../CountryCodeSelect";
import styles from "./PhoneInput.module.scss";
import classnames from "classnames";
import { Svg } from "@whatslly/ui-components/v2/BaseElements/Svg";

type PhoneInputProps = {
  selectedCountryCodes?: SelectedCountriesType;
  mostUsedCountryCodes?: CountryCodesCountType[];
  countryCode: string;
  phoneNumberWithOutCountryCode: string;
  onPhoneChange: (phoneNumber: string) => void;
  onCountryCodeChange: (code: string) => void;
  testid?: string;
  disableCountryCodeAutoPick?: boolean;
  disableBackgroundColor?: boolean;
  shouldShowCancelButton?: boolean;
  onCancel?: () => void;
};

export const PhoneInput: React.FC<PhoneInputProps> = React.memo(
  ({
    countryCode,
    selectedCountryCodes,
    mostUsedCountryCodes,
    onPhoneChange,
    onCountryCodeChange,
    phoneNumberWithOutCountryCode,
    testid,
    disableCountryCodeAutoPick,
    disableBackgroundColor,
    shouldShowCancelButton,
    onCancel,
  }) => {
    const textInputRef = useRef<HTMLInputElement>(null);
    const handleCountryCodeChange = useCallback(
      (code: string) => {
        onCountryCodeChange(code);
        textInputRef.current?.focus();
      },
      [onCountryCodeChange]
    );
    return (
      <div className={styles.phoneNumberInputs}>
        <div className={styles.selectContainer}>
          <CountryCodeSelect
            testId={testid}
            disableBackgroundColor={disableBackgroundColor}
            handleCountryCodeChange={handleCountryCodeChange}
            selectedCountryCodes={selectedCountryCodes}
            mostUsedCountryCodes={mostUsedCountryCodes}
            countryCode={countryCode}
            disableAutoPick={disableCountryCodeAutoPick}
          />
        </div>
        <div className={classnames(styles.textInputContainer, { [styles.disableBackgroundColor]: disableBackgroundColor })}>
          {shouldShowCancelButton && onCancel && (
            <Svg onClick={onCancel} iconName={"cancel-actions"} width={12} height={12} className={styles.removeButton} />
          )}
          <input
            data-testid={testid}
            ref={textInputRef}
            autoFocus
            className={styles.textInput}
            onChange={(e) => onPhoneChange(e.target.value.replace(/[^0-9]/g, ""))}
            value={phoneNumberWithOutCountryCode}
          />
        </div>
      </div>
    );
  }
);
